// extracted by css-extract-rspack-plugin
export default {"button_override":"uEvuM","buttonOverride":"uEvuM","#":"yUE5G","button_label":"CjETD","buttonLabel":"CjETD"};